const NbsTransactionApiUrls = {
  GET: `${process.env.REACT_APP_USER_ACI_SHARED_URL}/shared/nbsBilling/get`
};

export default NbsTransactionApiUrls
